/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TeacherLoadRow } from './TeacherLoadRow';
import {
    TeacherLoadRowFromJSON,
    TeacherLoadRowFromJSONTyped,
    TeacherLoadRowToJSON,
    TeacherLoadRowToJSONTyped,
} from './TeacherLoadRow';

/**
 * 
 * @export
 * @interface TeacherLoadWidgetData
 */
export interface TeacherLoadWidgetData {
    /**
     * 
     * @type {Array<TeacherLoadRow>}
     * @memberof TeacherLoadWidgetData
     */
    items: Array<TeacherLoadRow>;
}

/**
 * Check if a given object implements the TeacherLoadWidgetData interface.
 */
export function instanceOfTeacherLoadWidgetData(value: object): value is TeacherLoadWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function TeacherLoadWidgetDataFromJSON(json: any): TeacherLoadWidgetData {
    return TeacherLoadWidgetDataFromJSONTyped(json, false);
}

export function TeacherLoadWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeacherLoadWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(TeacherLoadRowFromJSON)),
    };
}

export function TeacherLoadWidgetDataToJSON(json: any): TeacherLoadWidgetData {
    return TeacherLoadWidgetDataToJSONTyped(json, false);
}

export function TeacherLoadWidgetDataToJSONTyped(value?: TeacherLoadWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(TeacherLoadRowToJSON)),
    };
}

